import React, { useState, useCallback, useEffect } from 'react';
import { Container, Grid } from '@mui/material';
import FeedAlgoExplorerColumn from '../feed_algos/FeedAlgoExplorerColumn';
import FeedAlgoEditorColumn from '../feed_algos/FeedAlgoEditorColumn';
import { useDeploy } from '../contexts/DeployContext';
import { useGlobal } from '../contexts/GlobalContext';

const FeedsService = () => {
  const { setCurrentContext, mergeCurrentContext } = useGlobal();
  const { deployApi } = useDeploy();
  const [editingFeed, setEditingFeed] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSaved = useCallback(() => {
    setRefreshKey((k) => k + 1);
    setEditingFeed(null);
  }, []);

  const handleClearEdit = useCallback(() => {
    setEditingFeed(null);
  }, []);

  const handleDeleteFeed = useCallback(
    async (feed) => {
      if (!feed?.algo_id) return;
      await deployApi.deleteFeedAlgo(feed.algo_id);
      setRefreshKey((k) => k + 1);
      setEditingFeed(null);
    },
    [deployApi]
  );

  useEffect(() => {
    setCurrentContext({
      product: 'deploy',
      page: 'feed_algos',
    });
    return () => setCurrentContext(null);
  }, [setCurrentContext]);

  useEffect(() => {
    mergeCurrentContext({
      editingFeed: editingFeed ? { algo_id: editingFeed.algo_id, algorithm: editingFeed.algorithm } : undefined,
    });
  }, [editingFeed, mergeCurrentContext]);

  return (
    <Container maxWidth="xl" sx={{ mt: 2 }}>
      <Grid container spacing={2} sx={{ width: '100%', alignItems: 'flex-start', minHeight: 'calc(100vh - 120px)' }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <FeedAlgoExplorerColumn
            refreshKey={refreshKey}
            onEditFeed={setEditingFeed}
            onDeleteFeed={handleDeleteFeed}
            onDuplicateFeed={setEditingFeed}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FeedAlgoEditorColumn
            editingFeed={editingFeed}
            onSaved={handleSaved}
            onClearEdit={handleClearEdit}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default FeedsService;
